import { createSelector } from 'reselect';
import { reduce } from 'lodash/fp';

const reduceAds = reduce((memo, item) => {
  if (!item.slot) {
    if (memo.length === 0) {
      return memo;
    }

    const prev = memo[memo.length - 1];
    return [
      ...memo.slice(0, memo.length - 1),
      {
        ...prev,
        screenModes: [...prev.screenModes, ...item.screenModes]
      }
    ];
  }

  return [...memo, item];
}, []);

function getAdverts(adConfig) {
  if (!adConfig) {
    return [];
  }

  return reduceAds([
    {
      slot: adConfig.xsmall,
      screenModes: ['mobile']
    },
    {
      slot: adConfig.small,
      screenModes: ['tabletPortrait']
    },
    {
      slot: adConfig.medium,
      screenModes: ['tabletLandscape']
    },
    {
      slot: adConfig.large,
      screenModes: ['desktop']
    },
    {
      slot: adConfig.xlarge,
      screenModes: ['desktopLarge']
    }
  ]);
}

function makeAdvertsSelector() {
  return createSelector(
    (state, props) => state.settings.doubleClick[props.zone],
    getAdverts
  );
}

export default makeAdvertsSelector;
